import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { BadgeColor } from './badge.types';
import type { IconName } from '../../common/icon/icons.type';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.less', './badge-overwrites.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'color',
  },
  imports: [IconComponent, NgTemplateOutlet],
})
export class BadgeComponent {
  @Input() public color: BadgeColor;
  @Input() public iconName: IconName;
  @Input() public iconTmpl?: TemplateRef<any> | null;
  @Input() public iconTmplContext?: Record<string, any> | null;
  @Input() public text: string | number;
}
